import { useQuery } from "@tanstack/react-query";

import { appointmentsApi } from "@/api";
import { QueryKey } from "@/query/Query";

/**
 * One counselor's future eligible appointments, so they can be marked or unmarked for takeover.
 * Nested under the takeovers query key on purpose: the mutations invalidate that prefix, so a
 * marked appointment reaches both lists without them having to know about each other. The counselor
 * segment keeps this out of the cache entry useTakeoverQuery reads, which the same endpoint would
 * otherwise fill with the wrong rows while no counselor is picked. Nothing is requested until a
 * counselor is picked — without one there is nothing to show.
 */
export function useCounselorAppointmentsQuery(counselorId?: string) {
  return useQuery({
    queryKey: [QueryKey.AppointmentTakeovers, "counselor", counselorId ?? null],
    queryFn: () => appointmentsApi.getAppointmentsForTakeover({ counselorId }),
    enabled: counselorId !== undefined,
  });
}
